import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { z } from "zod";
//#region src/central/v3/content-destinations/post/republish.ts
var republish_exports = /* @__PURE__ */ __exportAll({ RequestSchema: () => RequestSchema });
var RequestSchema = z.object({
	endPosition: z.string().optional(),
	hidden: z.boolean().optional(),
	published: z.boolean().optional(),
	startPosition: z.string().optional(),
	title: z.string(),
	webEventProfileId: z.string()
});
//#endregion
export { republish_exports };

//# sourceMappingURL=republish.js.map